import { useLocation, useNavigate } from "react-router-dom";
import { ArrowLeft, Plus, Pencil, Trash2 } from "lucide-react";
import { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import Select from "react-select";

export default function Pricing() {
  const location = useLocation();
  const navigate = useNavigate();

  const [isEditMode, setIsEditMode] = useState(false);
  const [editId, setEditId] = useState(null);

  const [productlist, setProductlist] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [customerPrice, setCustomerPrice] = useState("");
  const [loading, setLoading] = useState(false);
  const [pricelist, setPricelist] = useState([]);

  const { id, customername, type } = location.state || {};

  // ================= Customer Id =================
  // console.log("Customer Id is:", id);
  // console.log("Customer Name is:", customername);
  // console.log("Customer Type is:", type);

  // ================= FETCH PRODUCTS =================
  useEffect(() => {
    fetchProducts();
    fetchPricinglist();
  }, []);

  const fetchProducts = () => {
    axios
      .get("http://tntyping.com/Adminconsole/api/nutsproductslist")
      .then((response) => {
        if (response.data.errorCode === 0) {
          setProductlist(response.data.result);
        }
      });
  };

  // ================= PRICE LISTS =================
  const fetchPricinglist = () => {
    axios
      .get("http://tntyping.com/Adminconsole/api/nutscustomerproductpricelist")
      .then(function (response) {
        console.log("Response: ", response);
        if (response.data.errorCode === 2) {
          Swal.fire({
            icon: "error",
            text: response.data.Message,
            width: 320,
            padding: "1em",
            confirmButtonText: "OK",
            customClass: {
              popup: "rounded-xl text-sm"
            }
          });
          return;
        }

        if (response.data.errorCode === 0) {
          setPricelist(response.data.result);
        }
      });
  };

  const customerPrices = pricelist.filter(
    (item) => item.customerid === String(id)
  );

  // ================= PRODUCT LISTS =================
  const productOptions = productlist.map((item) => ({
    label2: item.productname,
    label: `${item.productname} (Base Price ₹${item.price})`,
    value: item.id,
    basePrice: item.price,
    productname: item.productname
  }));

  // ================= PRICE LISTS =================
  const handleSavePrice = async () => {
    if (!selectedProduct) {
      Swal.fire({ icon: "warning", text: "Select product" });
      return;
    }

    if (!customerPrice) {
      Swal.fire({ icon: "warning", text: "Enter customer price" });
      return;
    }
    try {
      await axios
        .post(
          "http://tntyping.com/Adminconsole/api/" +
            "nutscreatecustomersproductprice?customerid=" +
            id +
            "&customername=" +
            customername +
            "&productid=" +
            selectedProduct.value +
            "&productname=" +
            selectedProduct.label2 +
            "&price=" +
            customerPrice
        )
        .then(function (response) {
          console.log("The response is", response);
          if (response.data.errorCode === 2) {
            Swal.fire({
              icon: "error",
              text: response.data.Message,
              width: 320,
              padding: "1em",
              confirmButtonText: "OK",
              customClass: {
                popup: "rounded-xl text-sm"
              }
            });
            return;
          }

          if (response.data.errorCode === 0) {
            Swal.fire({
              icon: "success",
              text: "Price Added Successfully",
              timer: 1500,
              showConfirmButton: false,
              width: 320,
              padding: "1em",
              confirmButtonText: "OK",
              customClass: {
                popup: "rounded-xl text-sm"
              }
            });
            return;
          }
        });
      setLoading(true);
      fetchPricinglist();
      setShowModal(false);
      setSelectedProduct(null);
      setCustomerPrice("");
    } catch (error) {
      Swal.fire({
        icon: "error",
        text: "Something went wrong"
      });
    } finally {
      setLoading(false);
    }
  };

  // ================= ON EDIT =================
  const onEdit = (item) => {
    setIsEditMode(true);
    setEditId(item.id);

    setCustomerPrice(item.price);

    setSelectedProduct({
      value: item.productid,
      label: item.productname
    });

    setShowModal(true);
  };

  // ================= HANDLE UPDATED PRICE =================
  const handleUpdatePrice = async () => {
    if (!customerPrice) {
      Swal.fire({ icon: "warning", text: "Enter customer price" });
      return;
    }

    try {
      const response = await axios.post(
        "http://tntyping.com/Adminconsole/api/editcustomerproductpricebyid?id=" +
          editId +
          "&price=" +
          customerPrice
      );

      if (response.data.errorCode === 0) {
        Swal.fire({
          icon: "success",
          text: "Price Updated Successfully",
          timer: 1500,
          showConfirmButton: false,
          width: 320,
          customClass: {
            popup: "rounded-xl text-sm"
          }
        });

        fetchPricinglist();
        setShowModal(false);
        setCustomerPrice("");
        setSelectedProduct(null);
        setIsEditMode(false);
        setEditId(null);
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        text: "Something went wrong"
      });
    }
  };

  // ================= HANDLE ON DELETE PRICE =================
  const onDelete = (item) => {
    Swal.fire({
      text: "Do you want to delete this price?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      width: 320,
      customClass: {
        popup: "rounded-xl text-sm"
      }
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await axios.post(
            "http://tntyping.com/Adminconsole/api/deletecustomerproductpricebyid?id=" +
              item.id
          );

          if (response.data.errorCode === 0) {
            Swal.fire({
              icon: "success",
              text: "Price Deleted Successfully",
              timer: 1500,
              showConfirmButton: false,
              width: 320,
              customClass: {
                popup: "rounded-xl text-sm"
              }
            });

            fetchPricinglist();
          }
        } catch (error) {
          Swal.fire({
            icon: "error",
            text: "Delete failed"
          });
        }
      }
    });
  };

  return (
    <div className="p-6 space-y-6 bg-gray-50 min-h-screen">
      {/* ===== Header ===== */}
      <div className="flex justify-between items-center">
        <div>
          <h2 className="text-2xl font-bold text-gray-800">
            Pricing Management
          </h2>
          <p className="text-sm text-gray-500">
            Manage pricing for selected customer
          </p>
        </div>

        <button
          onClick={() => navigate(-1)}
          className="flex items-center gap-2 bg-gray-200 hover:bg-gray-300 px-4 py-2 rounded-lg text-sm"
        >
          <ArrowLeft size={16} />
          Back
        </button>
      </div>

      {/* ===== Customer Info ===== */}
      <div className="bg-white rounded-xl shadow-sm p-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-sm">
          <div>
            <p className="text-gray-500">Customer Name</p>
            <p className="font-medium text-gray-700">{customername}</p>
          </div>

          <div>
            <p className="text-gray-500">Customer Type</p>
            <p className="font-medium text-blue-600">{type}</p>
          </div>

          <div>
            <p className="text-gray-500">Customer ID</p>
            <p className="font-medium text-gray-700">{id}</p>
          </div>
        </div>
      </div>

      {/* ===== Pricing Table ===== */}
      <div className="bg-white rounded-xl shadow-sm overflow-hidden">
        <div className="flex justify-between items-center p-4 border-b bg-gray-50">
          <h3 className="text-sm font-semibold text-gray-700">
            Product Pricing List
          </h3>

          <button
            onClick={() => setShowModal(true)}
            className="flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg shadow-sm text-sm"
          >
            <Plus size={16} />
            Add Price
          </button>
        </div>

        <table className="w-full text-sm">
          <thead className="bg-gray-100 text-gray-600 uppercase text-xs tracking-wider">
            <tr>
              <th className="p-4 text-left">Product</th>
              <th className="p-4 text-left">MRP Price</th>
              <th className="p-4 text-left">Customer Price</th>
              <th className="p-4 text-center">Actions</th>
            </tr>
          </thead>

          <tbody>
            {customerPrices.length === 0 ? (
              <tr className="border-t">
                <td colSpan="4" className="p-6 text-center text-gray-400">
                  No pricing data available.
                </td>
              </tr>
            ) : (
              customerPrices.map((item) => {
                const product = productlist.find(
                  (p) => p.id === Number(item.productid)
                );

                return (
                  <tr key={item.id} className="border-t hover:bg-gray-50">
                    <td className="p-4 font-medium text-gray-700">
                      {item.productname}
                    </td>

                    <td className="p-4 text-gray-600">
                      ₹{product ? product.price : "-"}
                    </td>

                    <td className="p-4 text-green-600 font-semibold">
                      ₹{item.price}
                    </td>

                    <td className="p-4 flex justify-center gap-4">
                      <button
                        className="text-blue-600 hover:text-blue-800"
                        onClick={() => onEdit(item)}
                      >
                        <Pencil size={18} />
                      </button>

                      <button
                        className="text-red-500 hover:text-red-700"
                        onClick={() => onDelete(item)}
                      >
                        <Trash2 size={18} />
                      </button>
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>

      {/* ===== Modal ===== */}
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded-2xl w-96 space-y-4 shadow-xl">
            <h3 className="text-lg font-semibold text-gray-800">
              {isEditMode ? "Edit Customer Price" : "Add Customer Price"}
            </h3>

            <Select
              options={productOptions}
              value={selectedProduct}
              onChange={(option) => setSelectedProduct(option)}
              placeholder="Select Product"
              className="text-sm"
            />

            {selectedProduct && (
              <p className="text-sm text-gray-500">
                Base Price: ₹{selectedProduct.basePrice}
              </p>
            )}

            <input
              type="number"
              placeholder="Customer Price"
              className="border w-full px-3 py-2 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
              value={customerPrice}
              onChange={(e) => setCustomerPrice(e.target.value)}
            />

            <div className="flex justify-end gap-3 pt-2">
              <button
                onClick={() => setShowModal(false)}
                className="px-4 py-2 text-gray-600 hover:text-black"
              >
                Cancel
              </button>

              <button
                onClick={isEditMode ? handleUpdatePrice : handleSavePrice}
                disabled={loading}
                className={`px-4 py-2 rounded-lg text-white ${
                  loading ? "bg-green-400" : "bg-green-600 hover:bg-green-700"
                }`}
              >
                {loading ? "Saving..." : isEditMode ? "Update" : "Save"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
